import classNames from 'classnames';
import { t } from 'ttag';

import { Title } from '@ui/Title';

import s from './ProfileAbout.sss';

type ProfileAboutProps = {
  text: Maybe<string>
  className?: string
};

export const ProfileAbout: React.FC<ProfileAboutProps> = ({
  text,
  className,
}) => (
  <div className={classNames(s.root, className)}>
    {
    text || (
      <div className={s.noText}>
        <Title type="h5" bold={false}>{t`Тут поки пусто`}</Title>
        <div className={s.noTextSubtitle}>{t`Продавець поки не розмістив опис`}</div>
      </div>
    )
  }
  </div>
);
